export default (theme) => ({
    wrapper: {
        display: 'grid',
        gridTemplateRows: '0fr',
        transition: 'grid-template-rows 300ms cubic-bezier(0.4, 0, 0.2, 1)',
        width: '100%',
        position: 'relative',
    },
    wrapperExpanded: {
        gridTemplateRows: '1fr',
    },
    wrapperDismissible: {
        '&:hover': {
            '& $root': {
                borderColor: theme.colors.grey[100],
            },
            '& $dismissButton': {
                opacity: 1,
                pointerEvents: 'auto',
            },
        },
    },
    wrapperInner: {
        overflow: 'hidden',
    },
    content: {
        opacity: 0,
        transition: 'opacity 200ms ease',
    },
    contentVisible: {
        opacity: 1,
    },
    root: {
        alignItems: 'center',
        backgroundColor: theme.colors.semantic.negative100,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.colors.transparent,
        borderRadius: 6,
        display: 'flex',
        gap: 8,
        padding: 8,
        width: '100%',
    },
    message: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        flex: 1,
        maxHeight: 200,
        overflow: 'auto',
        ...theme.utils.scrollbar,
        '& *': {
            lineHeight: 1.4,
        },
        '& strong': {
            fontWeight: 500,
        },
    },
    dismissButton: {
        cursor: 'pointer',
        flexShrink: 0,
        opacity: 0,
        pointerEvents: 'none',
        transition: 'opacity 0.2s ease',
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        position: 'absolute',
        right: -8,
        top: -8,
        border: `1px solid ${theme.colors.grey[100]}`,
        backgroundColor: theme.colors.primary.white,
        boxShadow: '2px -1px 6px 0px #0000001A',
    },
    artifacts: {
        paddingTop: 8,
    },
});
